import { render, staticRenderFns } from "./TeamplannerGroupHeaderCard.vue?vue&type=template&id=3696f6d1"
import script from "./TeamplannerGroupHeaderCard.vue?vue&type=script&lang=js"
export * from "./TeamplannerGroupHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports